import { useQuery } from '@tanstack/react-query'
import { getWorkerProfile } from 'api/company/worker/profile'
import { QueryOptions } from 'queries/types'
import { workerKeys } from './keys'

export function useWorkerProfile(
  workerId: number,
  options: QueryOptions<typeof getWorkerProfile> = {}
) {
  return useQuery({
    ...options,
    enabled: !!workerId && (options.enabled ?? true),
    queryKey: workerKeys.profile(workerId),
    queryFn: () => getWorkerProfile(workerId),
  })
}
